import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Callback from '@/components/Callback.vue'
import Resources from '@/components/Resources.vue'
import Jobs from '@/components/Jobs/Index.vue'
import Admin from '@/components/admin/Index.vue'
import AdminRemodelers from '@/components/admin/Remodelers/index.vue'
import AdminJobs from '@/components/admin/Jobs/index.vue'
import AdminJob from '@/components/admin/Jobs/job.vue'
import AdminRemodelerProfile from '@/components/admin/Remodelers/Profile.vue'
import Profile from '@/components/Profile.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: (to, from, next) => {
        router.push('resources')
      }
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback
    },
    {
      path: '/resources',
      name: 'resources',
      component: Resources
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: Jobs
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      beforeEnter: (to, from, next) => {
        if (router.app.$auth.role === 'Super Admin' || router.app.$auth.role === 'Territory Manager') {
          next()
        } else {
          router.push('resources')
        }
      },
      children: [
        {
          path: 'remodelers',
          name: 'adminRemodelers',
          component: AdminRemodelers
        },
        {
          path: 'jobs',
          name: 'adminJobs',
          component: AdminJobs
        },
        {
          path: 'remodeler/:id',
          name: 'adminRemodeler',
          component: AdminRemodelerProfile
        },
        {
          path: 'job/:id',
          name: 'adminjob',
          component: AdminJob
        }
      ]
    },
    {
      path: '*',
      component: Resources
    }
  ]
})

// very basic "setup" of a global guard
router.beforeEach((to, from, next) => {
  if (to.name === 'callback') { // check if "to"-route is "callback" and allow access
    next()
  } else if (router.app.$auth.isAuthenticated() && router.app.$auth.role) { // if authenticated allow access
    // router.app.$http.defaults.headers['Authorization'] = 'Bearer ' + router.app.$auth.accessToken
    if (router.app.$http.defaults.headers['Authorization']) {
      next()
    } else {
      router.app.$http.defaults.headers['Authorization'] = 'Bearer ' + router.app.$auth.accessToken
      next()
    }
  } else { // trigger auth0 login
    router.app.$auth.login()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js